import styled from "styled-components";

export const StyledButton = styled.button<{ $theme?: string, $width: number | string | undefined, $height: number | string | undefined}>`
  background: ${props => props.$theme === 'dark' ? "#6E30E8" : props.$theme === 'medium' ? "#00D6D6" : "#FFF"};
  color: ${props => props.$theme === 'dark' ? "#FFF" : props.$theme === 'medium' ? "#FFF" : "#4D4D4D"};
  border: 0;
  cursor: pointer;
  border: 1.5px solid #6E30E8;
  border-radius: 8px;
  width: ${props => props.$width !== undefined ? props.$width.toString() + 'px' : '100%'};
  height: ${props => props.$height !== undefined ? props.$height.toString() + 'px' : 'auto'};
  font-family: Inter-Regular;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 125%;

  &:hover {
    // background: ${props => props.$theme === 'dark' ? "#4D4D4D" : props.$theme === 'medium' ? "#00B3B3" : "#F2F2F2"};
  }
`;